module.exports = __webpack_public_path__ + "stylesheets/section-background-text_c5cb196efb17edc51ddde9a4648c9942.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing-template/components/sections/section-background-text.less
// module id = y+GP
// module chunks = 118